import { action, computed, observable } from 'mobx';
import moment from 'moment';
import { SchoolType } from '../../enums';

export default class BannerAudienceFilter {
    constructor(filter?: Partial<BannerAudienceFilter>) {
        if (filter) this.update(filter);
    }

    @observable registrationDateFrom: moment.Moment | null = null;
    @observable registrationDateTo: moment.Moment | null = null;
    @observable billingPlanIds: string[] = [];
    @observable schoolTypes: SchoolType[] = [];

    @computed get isEmpty(): boolean {
        return !this.registrationDateFrom
            && !this.registrationDateTo
            && (!this.billingPlanIds || this.billingPlanIds.length === 0)
            && (!this.schoolTypes || this.schoolTypes.length === 0);
    }

    @action update(filter: Partial<BannerAudienceFilter>) {
        if (filter.registrationDateFrom !== undefined) this.registrationDateFrom = filter.registrationDateFrom;
        if (filter.registrationDateTo !== undefined) this.registrationDateTo = filter.registrationDateTo;
        if (filter.billingPlanIds !== undefined) this.billingPlanIds = filter.billingPlanIds;
        if (filter.schoolTypes !== undefined) this.schoolTypes = filter.schoolTypes;
    }

    toJson() {
        return {
            registrationDateFrom: this.registrationDateFrom?.toISOString() ?? null,
            registrationDateTo: this.registrationDateTo?.toISOString() ?? null,
            billingPlanIds: this.billingPlanIds ?? [],
            schoolTypes: this.schoolTypes ?? [],
        };
    }

    clone(): BannerAudienceFilter {
        return new BannerAudienceFilter({
            registrationDateFrom: this.registrationDateFrom ? moment(this.registrationDateFrom) : null,
            registrationDateTo: this.registrationDateTo ? moment(this.registrationDateTo) : null,
            billingPlanIds: this.billingPlanIds ? [...this.billingPlanIds] : [],
            schoolTypes: this.schoolTypes ? [...this.schoolTypes] : [],
        });
    }

    serialize(): string | null {
        return this.isEmpty ? null : JSON.stringify(this.toJson());
    }

    static fromJson(json: any): BannerAudienceFilter {
        if (!json) return new BannerAudienceFilter();
        return new BannerAudienceFilter({
            registrationDateFrom: json.registrationDateFrom ? moment(json.registrationDateFrom) : null,
            registrationDateTo: json.registrationDateTo ? moment(json.registrationDateTo) : null,
            billingPlanIds: Array.isArray(json.billingPlanIds) ? json.billingPlanIds : [],
            schoolTypes: Array.isArray(json.schoolTypes) ? json.schoolTypes : [],
        });
    }

    static deserialize(json: string | null | undefined): BannerAudienceFilter {
        if (!json) return new BannerAudienceFilter();
        try {
            return BannerAudienceFilter.fromJson(JSON.parse(json));
        } catch {
            return new BannerAudienceFilter();
        }
    }
}
